// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';


import Product from './components/icons/Product';
import Admin from './components/icons/Admin';
import User from './components/icons/User';
import UserDetails from './components/icons/UserDetails';
import Role from './components/icons/Role';
import DataUpload from './components/icons/DataUpload';
import Price from './components/icons/Price';
import Report from './components/icons/Report';
import Customer from './components/icons/Customer';
// import CustomerDetails from './components/icons/CustomerDetails';
// import Address from './components/icons/Address';
import Inventory from './components/icons/Inventory';
import Payment from './components/icons/Payment';
import Invoice from './components/icons/Invoice';
import Enquiry from './components/icons/Enquiry';
import Offer from './components/icons/Offer';
import Order from './components/icons/Order';
// import OrderDetailsPage from './components/icons/OrderDetails'; 
// import OrderItemsPage from './components/icons/OrderItems';
// import INV from './components/icons/INV';
import UploadFile from './components/icons/UploadFile';
// import OfferQuotationApp from './components/icons/OfferQuotationApp'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/product" element={<Product />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/user" element={<User />} />
        <Route path="/user/details" element={<UserDetails />} />
        <Route path="/user/role" element={<Role />} />
        <Route path="/dataupload" element={<DataUpload />} />
        <Route path="/price" element={<Price />} />
        <Route path="/report" element={<Report />} />
        <Route path="/customer" element={<Customer />} />
        {/* <Route path="/customer/details" element={<CustomerDetails />} /> */}
        {/* <Route path="/customer/address" element={<Address />} /> */}
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/order" element={<Order />} />
        {/* <Route path="/order/details" element={<OrderDetailsPage />} />
        <Route path="/order/items" element={<OrderItemsPage />} /> */}
        {/* <Route path="/inv" element={<INV />}/> */}
        <Route path="/uploadfile" element={<UploadFile />}/>
        {/* <Route path="/poffer" element={<OfferQuotationApp/>}/> */}
      </Routes>
    </Router>
  );
}

export default App;



//Version-2
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ProtectedRoute from './components/ProtectedRoute';
// import Dashboard from './components//Dashboard';
// import Products from './components/icons/Product';
// import Orders from './components/icons/Order';
// import Customers from './components/icons/Customer';
// import Login from './components/Login';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />

//         <Route
//           path="/dashboard"
//           element={
//             <ProtectedRoute page="Dashboard">
//               <Dashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/product"
//           element={
//             <ProtectedRoute page="Product">
//               <Products />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/order"
//           element={
//             <ProtectedRoute page="Order">
//               <Orders />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/customer"
//           element={
//             <ProtectedRoute page="Customers">
//               <Customers />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
